var map = {
	"./de/btn-detail.png": "XyEg",
	"./en/btn-detail.png": "gkaH",
	"./es/btn-detail.png": "2/TM",
	"./fr/btn-detail.png": "NxL/",
	"./ja/btn-detail.png": "D0ts",
	"./ko/btn-detail.png": "FcSv",
	"./pt/btn-detail.png": "H2+Y",
	"./ru/btn-detail.png": "wUu6",
	"./th/btn-detail.png": "Y+OW",
	"./zh-Hant/btn-detail.png": "47Rv"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sRR3";